import { styled } from '@mui/material';
import { PaymentElement } from '@stripe/react-stripe-js';

export const StripePaymentElement = styled(PaymentElement)(() => ({
  width: '100%',
}));
